import React from "react";
import DropDownNew from "../Form/DropDownNew";
import Input from "../Form/Input";
import CustomButton from "../Form/CustomButton";

const FormWrapper = ({
  title,
  dropdownLabel,
  dropdownOptions = [],
  dropdownValue,
  onDropdownChange,
  dropdownPlaceholder = "Select an option",
  showDropdown = true,
  dropdownError = "",
  textareaLabel = "Reason / Description",
  textareaPlaceholder,
  textareaValue,
  onTextareaChange,
  buttonLabel = "Submit",
  onSubmit,
  required = false,
  wrapperHeight = "h-[638px]",
  textareaError = "",
  loading = false,
}) => {
  return (
    <div className={`bg-white rounded-[8px] p-[20px] sm:p-[25px] md:p-[30px] w-full  mx-auto ${wrapperHeight}`}>
      {title && (
        <h2 className="text-[20px] sm:text-[22px] md:text-[24px] font-semibold mb-6 text-center">
          {title}
        </h2>
      )}

      {showDropdown && (
        <div className="mb-[60px] relative top-[28px]">
          <DropDownNew
            label={dropdownLabel}
            options={dropdownOptions}
            defaultOption={dropdownValue}
            onSelect={onDropdownChange}
            placeholder={dropdownPlaceholder}
            displayKey="label"
            idKey="value"
            allowFillColor={true}
            isForm={true}
            isRequired={required}
            buttonClassName="rounded-[5px] h-9 sm:h-[39px] md:h-[42px] lg:h-[45px] w-full sm:w-[270px] border border-[#81818180] placeholder:text-[12px] sm:placeholder:text-[13px] md:placeholder:text-[14px] lg:placeholder:text-[15px] placeholder:font-[400] placeholder:text-[#9D9D9D]"
            dropdownClassName="rounded-[0px] w-[270px] "
            labelStyle="-top-[27px] -left-1 text-[14px] sm:text-[15px] md:text-[16px] lg:text-[17px] font-inter font-[500] leading-[22px] text-[#09114C]"
          />
          {dropdownError && (
            <div className="text-red-400 text-[12px] mt-1 ml-2 font-normal font-inter">
              {dropdownError}
            </div>
          )}
        </div>
      )}

      <div className="mb-4 relative top-[0px] mt-[0px]">
        <Input
          type="textarea"
          name="description"
          label={textareaLabel}
          placeholder={textareaPlaceholder}
          value={textareaValue}
          onChange={onTextareaChange}
          isRequired={required}
          error={textareaError}
          labelStyle="block text-[14px] sm:text-[15px] md:text-[16px] lg:text-[17px] font-medium font-inter leading-[22px] text-[#09114C] mb-[5px]"
          inputStyle="min-h-[339px] placeholder:text-[12px] sm:placeholder:text-[13px] md:placeholder:text-[14px] lg:placeholder:text-[15px]"
          className="w-full resize-none placeholder:text-[12px] sm:placeholder:text-[13px] md:placeholder:text-[14px] lg:placeholder:text-[15px] placeholder:text-[#9D9D9D] placeholder:font-[400] border border-[#81818180] rounded-[5px] text-[14px] sm:text-[15px] md:text-[16px] lg:text-[17px] px-3 py-2 min-h-[339px]"
        />
      </div>

      <div className="text-center flex justify-center relative top-[33px] mt-[0px]">
        <CustomButton
          onClick={onSubmit}
          buttonText={buttonLabel}
          loading={loading}
          bgColor="bg-[#4772F1]"
          borderColor="border-[#4772F1]"
          textColor="text-white"
          width="min-w-[170px]"
          height="h-10 sm:h-[45px] md:h-[50px] lg:h-[55px]"
          className="text-[12px] sm:text-[14px] md:text-[16px] lg:text-[18px] border-[2px] border-[#4772F1] font-alexandria font-semibold px-6 leading-[100%] py-2 rounded-[8px]"
        />
      </div>
    </div>
  );
};

export default FormWrapper;
